module.exports = __webpack_public_path__ + "static/img/bp.356deff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/bp.png
// module id = 536
// module chunks = 1